import * as api from "./middleware/api.middleware";
import { getAuthHeader } from "./auth/authHeaders";

const serviceUrl = "logout";
const getAccessToken = () => getAuthHeader();

export function logout() {
  const getResponse = api.post<any>(`${serviceUrl}`, getAccessToken());
  return getResponse;
}
